import { useTranslation } from 'react-i18next';
import { useUser } from 'src/UserContext';

export default function PaymentEmail(): JSX.Element {
  const { t } = useTranslation();
  const { userInfo } = useUser();
  return (
    <div className="py-8">
      <div className="">{t('payment/purchase_email_title')}</div>
      <div className="mt-4 flex justify-start">
        <div className="N_14_R text-brown-grey">{t('payment/purchase_email')}</div>
        <div className="ml-4 N_14_R text-greyish-brown">{userInfo.email}</div>
      </div>
    </div>
  );
}
